import { Container, Grid, Hidden, Typography } from '@mui/material'
import { Box } from '@mui/system'
import Logo from './logo.svg'
import HeaderMobile from '../headerMain/HeaderMobile'
import './header.css'
import { useHistory } from 'react-router'
import { Link } from 'react-router-dom'
import { WalletMultiButton } from '@solana/wallet-adapter-react-ui'

export default function Header() {
  const history = useHistory()
  const link2 = [
    {
      name: 'HOME',
      link: '#home',
    },
    {
      name: 'TOKENOMICS',
      link: '#tokonomics',
    },
    {
      name: 'ROADMAP',
      link: '#roadMap',
    },
    {
      name: 'TEAM',
      link: '#ourTeam',
    },
    {
      name: 'Use Cases',
      link: '#useCase',
    },
    {
      name: 'MEDIA',
      link: '#media',
    },
    {
      name: 'SOLAR',
      link: 'https://solscan.io/token/2wmKXX1xsxLfrvjEPrt2UHiqj8Gbzwxvffr9qmNjsw8g',
    },
  ]

  return (
    <>
      <Box sx={{ position: 'fixed', top: '0', width: '100%', zIndex: '4' }}>
        <Container>
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            sx={{ padding: '3vh 2% 1vh 2%', zIndex: 2, margin: 'auto' }}
          >
            {/* logo  */}
            <Grid item xs={6} sm={2} md={2} lg={2} style={{ color: 'white' }}>
              <Link to="/">
                <img src={Logo} alt={Logo} width="100%" />
              </Link>
            </Grid>
            {/* my links  */}
            <Hidden mdDown>
              <Grid
                container
                item
                xs={10}
                sm={10}
                md={10}
                lg={10}
                justifyContent="flex-end"
                alignItems="center"
              >
                {link2.map((obj) => {
                  return (
                    <Grid item style={{ textAlign: 'center' }}>
                      <Typography
                        paragraph
                        fontSize={{ xs: '15px', md: '14px' }}
                        onClick={() => {
                          history.push('/')
                        }}
                      >
                        <a
                          href={obj.link}
                          style={{
                            color: 'white',
                            textDecoration: 'none',
                            padding: '10px',
                            fontWeight: 'bold',
                          }}
                        >
                          {' '}
                          {obj.name}{' '}
                        </a>
                      </Typography>
                    </Grid>
                  )
                })}

                <Grid item style={{ textAlign: 'center' }}>
                  <Typography
                    paragraph
                    fontSize={{ xs: '15px', md: '14px' }}
                    onClick={() => {
                      history.push('/')
                    }}
                  >
                    <a
                      href="/whitepaper.pdf"
                      onClick={() => null}
                      style={{
                        color: 'white',
                        textDecoration: 'none',
                        padding: '10px',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                      }}
                    >
                      Whitepaper
                    </a>
                  </Typography>
                </Grid>
                <Grid item style={{ textAlign: 'center' }}>
                  <Typography
                    paragraph
                    fontSize={{ xs: '15px', md: '14px' }}
                    sx={{ padding: '10px 0px' }}
                  >
                    <Link
                      to="/preSale"
                      style={{
                        color: 'white',
                        textDecoration: 'none',
                        padding: '10px',
                        fontWeight: 'bold',
                      }}
                      className="glow-on-hover"
                    >
                      Solar PreSale
                    </Link>
                  </Typography>
                </Grid>
                {/* <Grid item style={{ textAlign: 'center' }}>
                  <WalletMultiButton
                    style={{ marginBottom: '16px', marginLeft: '16px' }}
                  />
                </Grid> */}
              </Grid>
            </Hidden>

            <Hidden mdUp>
              <HeaderMobile />
            </Hidden>
          </Grid>
        </Container>
      </Box>
    </>
  )
}
